import React from 'react';
import Tooltip from 'components/Tooltip';

import { StateContainer } from './styles';

const SliderFieldStateContainer = ({ nameType, helperText, id, formErrors, formValid }) => (
  <StateContainer>
    <label className="st-slider-field--title" htmlFor={id}>
      # of {nameType}:{helperText && helperText != '' && <Tooltip>{helperText}</Tooltip>}
    </label>

    <div className={`st-slider-helper ${formValid[id] !== -1 && 'hidden'}`}>
      {formValid[id] === -1 ? formErrors[id] : ''}
    </div>
  </StateContainer>
);

export default SliderFieldStateContainer;
